<template>
    <div class="vsl-row vsl-multilingual-text-input-row" v-if="value">
        <h5 class="label">{{ label }}</h5>
        <div class="field">
            <label for="title_english" class="form-label">{{ $t("ui.vertical_scroll_layout.english_label") }}</label>
            <input type="text" class="form-control" id="title_english" v-model="value.en">
        </div>
        <div class="field">
            <label for="title_french" class="form-label">{{ $t("ui.vertical_scroll_layout.french_label") }}</label>
            <input type="text" class="form-control" id="title_french" v-model="value.fr">
        </div>

    </div>
</template>

<script>
export default {
    name: "VSLMultilingualTextInputRowRenderer",
    props: {
        label: String,
        value: Object
    }
}
</script>

<style scoped>

</style>